import React, { createContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const toastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
};

export const ToastNotificationContext = createContext();

const ToastNotificationContextProvider = (props) => {
  const notifySuccess = (title) => {
    toast.success(title, toastConfig);
  };

  const notifyError = (title) => {
    toast.error(title, toastConfig);
  };

  return (
    <ToastNotificationContext.Provider value={{ notifySuccess, notifyError }}>
      {props.children}
      <ToastContainer />
    </ToastNotificationContext.Provider>
  );
};

export default ToastNotificationContextProvider;
